import { useGetCourseDetailTotalEnrollmentsByCourseQueryQuery } from './graphql/get-course-detail-total-enrollments-by-course-query.v5.generated';

type TUseEnrollmentsByCourseProps = {
  courseId: number;
  skip?: boolean;
};

export const useTotalEnrollmentsByCourse = (
  args: TUseEnrollmentsByCourseProps,
) => {
  const { skip, courseId } = args;
  const { data, loading, error, refetch } =
    useGetCourseDetailTotalEnrollmentsByCourseQueryQuery({
      context: {
        clientName: 'v5',
      },
      variables: {
        input: {
          course_id: courseId,
          pagination: {
            first: 1,
          },
        },
      },
      skip,
    });

  const totalEnrollments =
    (data?.enrollments.get_users_by_assigned_courses_with_search.__typename ===
    'UserCourseInfoConnection'
      ? data.enrollments.get_users_by_assigned_courses_with_search.total_count
      : 0) ?? 0;
  const isEmptyEnrollments = totalEnrollments === 0;
  const isErrorByFragment =
    data?.enrollments.get_users_by_assigned_courses_with_search.__typename !==
    'UserCourseInfoConnection';

  const retryFetchEnrollments = () => {
    refetch();
  };

  return {
    isEmptyEnrollments,
    isErrorByFragment,
    totalEnrollments,
    loading,
    error,
    retryFetchEnrollments,
  };
};
